export type DropzoneUploaderKind = "video" | "image" | "pdf_image";

export function getAttachmentDropzoneKind(
  answerType: string | null | undefined,
  attributesType = "image",
): DropzoneUploaderKind {
  if (answerType === "pdf_image") return "pdf_image";
  if (attributesType === "video") return "video";
  return "image";
}

export const ACCEPTED_IMAGE_TYPES: string[] = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/svg+xml",
  "image/webp",
  "image/avif",
];

export const ACCEPTED_PDF_TYPE = "application/pdf";

export const ACCEPTED_FILE_TYPES: string[] = [
  ACCEPTED_PDF_TYPE,
  ...ACCEPTED_IMAGE_TYPES,
];

export const ACCEPTED_TYPES_BY_ANSWER_TYPE: Record<
  DropzoneUploaderKind,
  readonly string[]
> = {
  image: ACCEPTED_IMAGE_TYPES,
  video: ["video/*"],
  pdf_image: ACCEPTED_FILE_TYPES,
};

export const DROPZONE_IMAGE_EXTENSIONS: string[] = [
  "jpg",
  "jpeg",
  "png",
  "avif",
  "bmp",
  "gif",
  "svg",
  "webp",
  "heic",
  "heif",
];

export const DROPZONE_PDF_IMAGE_EXTENSIONS: string[] = [
  ...DROPZONE_IMAGE_EXTENSIONS,
  "pdf",
];

export const DROPZONE_VIDEO_EXTENSIONS: string[] = [
  "mp4",
  "webm",
  "mov",
  "m4v",
  "avi",
  "mkv",
  "ogv",
];

export const DROPZONE_ACCEPT_IMAGE: Record<string, string[]> = {
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/avif": [".avif"],
  "image/bmp": [".bmp"],
  "image/gif": [".gif"],
  "image/svg+xml": [".svg"],
  "image/webp": [".webp"],
  "image/heic": [".heic"],
  "image/heif": [".heif"],
};

export const DROPZONE_ACCEPT: Record<
  DropzoneUploaderKind,
  Record<string, string[]>
> = {
  image: DROPZONE_ACCEPT_IMAGE,
  pdf_image: {
    ...DROPZONE_ACCEPT_IMAGE,
    [ACCEPTED_PDF_TYPE]: [".pdf"],
  },
  video: {
    "video/*": [],
  },
};
